import controller from './search-box.controller';

const template = require('./search-box.html');

export default {
    bindings: {
        query: '<',
        onSearch: '&',
        onClear: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/common/search-box/search-box.component.js